//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppFilter from './Filter.vue';
import TransitionExpand from '../../global/transitions/Expand.vue'

export default {
	name: "AppFilters",
        props: ['group', 'initiallyExpanded', 'setFilterValue', 'executeSearch', 'showZeroResultFilters' ],
	components: { TransitionExpand, AppFilter },
	data() {
		return {
			open: this.initiallyExpanded,
			expanded: false,
			search: ''
		};
	},
	computed: {
		filterItems() {
			let sortedFilters;
			// We want to sort facets alphabetically when the filter count is not being displayed, and
			// right now, based on BE-only logic, the count is being hidden when it's an LRL page.
			if (this.config.isLrlPage) {
				sortedFilters = this.group.filters.sort((a, b) =>  {
					// Dates should still be newest to oldest
					if (!isNaN(parseInt(a.value)) && !isNaN(parseInt(b.value))) {
						return parseInt(b.value) - parseInt(a.value);
					}
					return a.value.localeCompare(b.value);
				});
			} else sortedFilters = this.group.filters;
			if (this.showZeroResultFilters) {
				return sortedFilters.filter(item => item.count >= 0 || item.selected);
			} else {
				return sortedFilters.filter(item => item.count > 0 || item.selected);
			}
		},
		filters() {
			return this.filterItems.filter(f => {
				return f.value.toLowerCase().trim().includes(this.search.toLowerCase().trim())
			});
		},
		filterToggleLabel() {
			let keyword = this.open ? 'Hide' : 'Show';
			return keyword + ' filter options for ' + this.group.name;
		},
		hiddenFilterGroups() {
			return !!this.$root.config.hiddenFilterGroups ? this.$root.config.hiddenFilterGroups.split(",").map(str => str.trim()) : [];
		}
	},
	methods: {
		toggle(state) {
			this[state] = !this[state];
		}
	},
	created() {},
	mounted() {},
};
